// Supermove
import {MutationResponse} from '@supermove/hooks';

// Example:
// {
//   data: {
//     response: {
//       errors: [{field: 'form.description', message: 'Bad input'}]
//     }
//   }
// }
export const isMutationError = (
  response: unknown,
): response is {data: MutationResponse<Record<string, unknown>>} => {
  return !!(
    typeof response === 'object' &&
    response &&
    'data' in response &&
    typeof response.data === 'object' &&
    response.data &&
    'response' in response.data &&
    typeof response.data.response === 'object' &&
    response.data.response &&
    'errors' in response.data.response &&
    Array.isArray(response.data.response.errors)
  );
};

export const isGqlError = (response: unknown) => {
  return response && typeof response === 'object' && 'error' in response && response.error;
};

// This works for our standard API calls. If needed, we can implement a custom hasError function
export const responseHasError = (response: unknown) => {
  return isGqlError(response) || isMutationError(response);
};

export const isValidationError = ({response}: MutationResponse<Record<string, unknown>>) => {
  return response.errors?.some((error) => error.field !== 'internal');
};
